// extracted by mini-css-extract-plugin
export default {"grid_sec":"style_grid_sec__FrQVG","left":"style_left__fPdAk","right":"style_right__KLA2L"};